export enum IkePoleForemanFieldIds {
	STATUS = 'ipf_status',
	ID = 'ipf_id',
	TAG_PHOTOS = 'ipf_tagPhotos',
	TYPE = 'ipf_type',
	OWNER = 'ipf_owner',
	TIP = 'ipf_tip',
	LOCATION = 'ipf_location',
	NOTE = 'ipf_note',
	PLA_RESULT = 'ipf_plaResult',
	IKE_PHOTO = 'ipf_ikePhoto',
	EQUIPMENT = 'ipf_equipment',
	EQUIPMENT_TYPE = 'ipf_equipmentType',
	EQUIPMENT_ORIENTATION = 'ipf_equipmentOrientation',
	EQUIPMENT_OWNER = 'ipf_equipmentOwner',
	EQUIPMENT_ATTACHMENT_HEIGHT = 'ipf_equipmentAttachmentHeight',
	EQUIPMENT_NOTE = 'ipf_equipmentNote',
	ANCHOR = 'ipf_anchor',
	ANCHOR_ASSEMBLY = 'ipf_anchorAssembly',
	ANCHOR_LEAD_LENGTH = 'ipf_anchorLeadLength',
	ANCHOR_OWNER = 'ipf_anchorOwner',
	ANCHOR_NOTE = 'ipf_anchorNote',
	ANCHOR_GUYS = 'ipf_anchorGuys',
	ANCHOR_GUY_SIZE = 'ipf_anchorGuySize',
	ANCHOR_GUY_OWNER = 'ipf_anchorGuyOwner',
	ANCHOR_GUY_ATTACHMENT_HEIGHT = 'ipf_anchorGuyAttachmentHeight',
	ANCHOR_GUY_STRUT_HEIGHT = 'ipf_anchorGuyStrutHeight',
	SPAN = 'ipf_span',
	SPAN_LENGTH = 'ipf_spanLength',
	SPAN_TYPE = 'ipf_spanType',
	SPAN_MID_SPAN_IKE_PHOTO = 'ipf_spanMidSpanIkePhoto',
	SPAN_NOTE = 'ipf_spanNote',
	SPAN_POWER_CIRCUIT = 'ipf_spanPowerCircuit',
	SPAN_POWER_CIRCUIT_TYPE = 'ipf_spanPowerCircuitType',
	SPAN_POWER_CIRCUIT_PRIMARY_CONDUCTOR = 'ipf_spanPowerCircuitPrimaryConductor',
	SPAN_POWER_CIRCUIT_PRIMARY_FRAMING = 'ipf_spanPowerCircuitPrimaryFraming',
	SPAN_POWER_CIRCUIT_PRIMARY_PHASE_A_HEIGHT = 'ipf_spanPowerCircuitPrimaryPhaseAHeight',
	SPAN_POWER_CIRCUIT_PRIMARY_PHASE_B_HEIGHT = 'ipf_spanPowerCircuitPrimaryPhaseBHeight',
	SPAN_POWER_CIRCUIT_PRIMARY_PHASE_C_HEIGHT = 'ipf_spanPowerCircuitPrimaryPhaseCHeight',
	SPAN_POWER_CIRCUIT_NEUTRAL_CONDUCTOR = 'ipf_spanPowerCircuitNeutralConductor',
	SPAN_POWER_CIRCUIT_NEUTRAL_FRAMING = 'ipf_spanPowerCircuitNeutralFraming',
	SPAN_POWER_CIRCUIT_NEUTRAL_HEIGHT = 'ipf_spanPowerCircuitNeutralHeight',
	SPAN_POWER_CIRCUIT_SECONDARY_CONDUCTOR = 'ipf_spanPowerCircuitSecondaryConductor',
	SPAN_POWER_CIRCUIT_SECONDARY_FRAMING = 'ipf_spanPowerCircuitSecondaryFraming',
	SPAN_POWER_CIRCUIT_SECONDARY_PHASE_A_HEIGHT = 'ipf_spanPowerCircuitSecondaryPhaseAHeight',
	SPAN_POWER_CIRCUIT_SECONDARY_PHASE_B_HEIGHT = 'ipf_spanPowerCircuitSecondaryPhaseBHeight',
	SPAN_POWER_CIRCUIT_SECONDARY_PHASE_C_HEIGHT = 'ipf_spanPowerCircuitSecondaryPhaseCHeight',
	SPAN_POWER_CIRCUIT_SHIELD_WIRE_CONDUCTOR = 'ipf_spanPowerCircuitShieldWireConductor',
	SPAN_POWER_CIRCUIT_SHIELD_WIRE_FRAMING = 'ipf_spanPowerCircuitShieldWireFraming',
	SPAN_POWER_CIRCUIT_SHIELD_WIRE_HEIGHT = 'ipf_spanPowerCircuitShieldWireHeight',
	SPAN_CIRCUIT_SPACER = 'ipf_spanCircuitSpacer',
	SPAN_CIRCUIT_SPACER_MESSENGER = 'ipf_spanCircuitSpacerMessenger',
	SPAN_CIRCUIT_SPACER_PHASE_SIZE = 'ipf_spanCircuitSpacerPhaseSize',
	SPAN_CIRCUIT_SPACER_SPACER_FRAMING = 'ipf_spanCircuitSpacerSpacerFraming',
	SPAN_CIRCUIT_SPACER_SPACER_ATTACHMENT_HEIGHT = 'ipf_spanCircuitSpacerSpacerAttachmentHeight',
	SPAN_CIRCUIT_SPACER_NEUTRAL_CONDUCTOR = 'ipf_spanCircuitSpacerNeutralConductor',
	SPAN_CIRCUIT_SPACER_NEUTRAL_FRAMING = 'ipf_spanCircuitSpacerNeutralFraming',
	SPAN_CIRCUIT_SPACER_NEUTRAL_HEIGHT = 'ipf_spanCircuitSpacerNeutralHeight',
	SPAN_CIRCUIT_SPACER_SECONDARY_CONDUCTOR = 'ipf_spanCircuitSpacerSecondaryConductor',
	SPAN_CIRCUIT_SPACER_SECONDARY_FRAMING = 'ipf_spanCircuitSpacerSecondaryFraming',
	SPAN_CIRCUIT_SPACER_SECONDARY_PHASE_A_HEIGHT = 'ipf_spanCircuitSpacerSecondaryPhaseAHeight',
	SPAN_CIRCUIT_SPACER_SECONDARY_PHASE_B_HEIGHT = 'ipf_spanCircuitSpacerSecondaryPhaseBHeight',
	SPAN_CIRCUIT_SPACER_SECONDARY_PHASE_C_HEIGHT = 'ipf_spanCircuitSpacerSecondaryPhaseCHeight',
	SPAN_CIRCUIT_AERIAL = 'ipf_spanCircuitAerial',
	SPAN_CIRCUIT_AERIAL_CABLE = 'ipf_spanCircuitAerialCable',
	SPAN_CIRCUIT_AERIAL_AERIAL_FRAMING = 'ipf_spanCircuitAerialAerialFraming',
	SPAN_CIRCUIT_AERIAL_AERIAL_ATTACHMENT_HEIGHT = 'ipf_spanCircuitAerialAerialAttachmentHeight',
	SPAN_CIRCUIT_AERIAL_NEUTRAL_CONDUCTOR = 'ipf_spanCircuitAerialNeutralConductor',
	SPAN_CIRCUIT_AERIAL_NEUTRAL_FRAMING = 'ipf_spanCircuitAerialNeutralFraming',
	SPAN_CIRCUIT_AERIAL_NEUTRAL_HEIGHT = 'ipf_spanCircuitAerialNeutralHeight',
	SPAN_CIRCUIT_AERIAL_SECONDARY_CONDUCTOR = 'ipf_spanCircuitAerialSecondaryConductor',
	SPAN_CIRCUIT_AERIAL_SECONDARY_FRAMING = 'ipf_spanCircuitAerialSecondaryFraming',
	SPAN_CIRCUIT_AERIAL_SECONDARY_PHASE_A_HEIGHT = 'ipf_spanCircuitAerialSecondaryPhaseAHeight',
	SPAN_CIRCUIT_AERIAL_SECONDARY_PHASE_B_HEIGHT = 'ipf_spanCircuitAerialSecondaryPhaseBHeight',
	SPAN_CIRCUIT_AERIAL_SECONDARY_PHASE_C_HEIGHT = 'ipf_spanCircuitAerialSecondaryPhaseCHeight',
	SPAN_CIRCUIT_FOSC = 'ipf_spanCircuitFosc',
	SPAN_CIRCUIT_FOSC_SIZE = 'ipf_spanCircuitFoscSize',
	SPAN_CIRCUIT_FOSC_FRAMING = 'ipf_spanCircuitFoscFraming',
	SPAN_CIRCUIT_FOSC_HEIGHT = 'ipf_spanCircuitFoscHeight',
	SPAN_COMMUNICATION = 'ipf_spanCommunication',
	SPAN_COMMUNICATION_MID_SPAN_HEIGHT = 'ipf_spanCommunicationMidSpanHeight',
	SPAN_COMMUNICATION_SIZE = 'ipf_spanCommunicationSize',
	SPAN_COMMUNICATION_OWNER = 'ipf_spanCommunicationOwner',
	SPAN_COMMUNICATION_HORIZ_OFFSET = 'ipf_spanCommunicationHorizOffset',
	SPAN_COMMUNICATION_ATTACHMENT_HEIGHT = 'ipf_spanCommunicationAttachmentHeight',
	SPAN_GUY = 'ipf_spanGuy',
	SPAN_GUY_SIZE = 'ipf_spanGuySize',
	SPAN_GUY_OWNER = 'ipf_spanGuyOwner',
	SPAN_GUY_INSULATOR = 'ipf_spanGuyInsulator',
	SPAN_GUY_ATTACHMENT_HEIGHT = 'ipf_spanGuyAttachmentHeight',
	SERVICES = 'ipf_services',
	SERVICE_LENGTH = 'ipf_serviceLength',
	SERVICE_POWER = 'ipf_servicePower',
	SERVICE_POWER_MID_SPAN_HEIGHT = 'ipf_servicePowerMidSpanHeight',
	SERVICE_POWER_CONDUCTOR = 'ipf_servicePowerConductor',
	SERVICE_POWER_HEIGHT = 'ipf_servicePowerHeight',
	SERVICE_POWER_ENDPOINT_HEIGHT = 'ipf_serviceEndpointHeight',
	SERVICE_COMMUNICATIONS = 'ipf_serviceCommunications',
	SERVICE_COMMUNICATIONS_MID_SPAN_HEIGHT = 'ipf_serviceCommunicationsMidSpanHeight',
	SERVICE_COMMUNICATIONS_CABLE = 'ipf_serviceCommunicationsCable',
	SERVICE_COMMUNICATIONS_HEIGHT = 'ipf_serviceCommunicationsHeight',
	SERVICE_COMMUNICATIONS_ENDPOINT_HEIGHT = 'ipf_serviceCommunicationsEndpointHeight',
}
